import React, { FC } from "react";
import BugsOverviewModal, { BugsOverviewModalProps } from "./BugsOverviewModal";
import { useBugReportErrorsStack } from "../../../../store/bugReport/useSelectors";

export type ContainerProps = Pick<
  BugsOverviewModalProps,
  "toggleModal" | "isModalOpen"
>;

const Container: FC<ContainerProps> = ({ isModalOpen, toggleModal }) => {
  const bugsErrorStack = useBugReportErrorsStack();
  return (
    <BugsOverviewModal
      isModalOpen={isModalOpen}
      toggleModal={toggleModal}
      errorsStack={bugsErrorStack}
    />
  );
};

export default Container;
